import React, { useState } from "react";
import ChecksList from "./ChecksList";
import CheckDetails from "./CheckDetails";
import Notifications from "./Notifications";
import classes from "./Body.module.css";
import Tabs from '../../../../components/Tabs';
import Aux from '../../../../components/AuxComponent';
import CommonUtil from '../../common';
import MenuUTIL from '../../../../util/menu-utils';
import constants from '../../../../globalization';
import Whiteboard from '../../../Playground/components/Body/Whiteboard';
import FireboardUtils from "../../../../util/fireboard-util";
import Button from "../../../../components/Button";
import redeemVoucherImg from '../../../../assets/images/Fireboard/action_buttons/redeem_points.png';
import modeEnums from "../../../../enums/modeEnums";
import CheckTilesView from '../CheckTilesView';
import ShapeInfoPopup from "../ShapeInfoPopup";

export default function Desktop(props) {
  const {
    setSelectedCheck = () => { },
    showSearchBox,
    selectedDate,
    onDateChange,
    onlineOrderAdvanceLimit,
    resetFilterCalendar,
    handleChange,
    searchChecks,
    onSearchReset,
    selectedItem = {},
    items = [],
    checksRowData = [],
    supportsTipsOnTotalAmount = false,
    showMemberDetailPopup = () => { },
    notificationsData = [],
    showNotifications = false,
    removeNewTag = () => { },
    onPrintPress,
    isFutureOrderType,
    getManagerNotifications,
    activeMgrFilter,
    managerMode,
    pendingItems,
    showApprovalReasonsPopup,
    currentView,
    selectedTable,
    shapes,
    onSelectShape = () => { },
    selectedShape,
    closeShapeInfoPopup,
    currency,
    iso2,
    suppressTipsOnFireBoard,
    acknowledgeIdCheck,
    sortModel,
    updateSortModel,
    onFooterIconPress,
    currentMode,
    pagination,
    checkFilters,
    storeInfo,
    onHandleSms,
    updateOrderStatus,
    deviceGroup,
    enableGpsLocation,
    latitude,
    longitude,
    viewGuestLocationOnMap,
    onRequestRefreshGuestGPS,
    onOrderDelivered,
    onClickSms,
    sensorsMap,
    fbVenueMode,
    onTabChange,
    openCaptureSeatNamePopup,
    sendPendingItems,
    pendingItems: orderPendingItems,
    enableAgeRestrictedOrderingForSeat,
    onUpdateAgeRestrictedItemsForSeat,
    enableAgeRestrictedOrderingForCheck,
    enableAgeVerification,
  } = props || {};
  const [counters, setCounters] = useState(new Map());

  const showVoucherChecks = currentMode === modeEnums.VOUCHER;

  if (showNotifications) {
    return (
      <div className={classes.container}>
        <Notifications
          notificationsData={notificationsData}
          removeNewTag={removeNewTag}
        />
      </div>
    );
  }

  const getTabView = () => {
    const tableChecks = selectedTable?.checks || [];
    return (
      <Tabs
        activeTab={selectedItem?.id}
        onTabChange={onTabChange}
        tabsContainerStyle={classes.tabsContainer}
        tabsStyle={classes.ulStyle}
      >
        {tableChecks.map(item => {
          let items = item && item.items;
          let pendingCheckItems = [];
          const isPOSOrder = CommonUtil.getOrderTypeFromSourceType(item.sourceType) === constants.orderType_POS;
          if (isPOSOrder) {
            items = FireboardUtils.updatePOSItems(item);
            const pendingItems = MenuUTIL.getPendingItemsFromCheck(item);
            pendingCheckItems = FireboardUtils.updatePendingPOSItems(pendingItems, item);
          }
          return <Aux id={item.id} name={item.number} key={item.id}>
            <CheckDetails
              checkDetailsStyles={classes.checksDetails}
              selectedItem={item}
              items={items}
              supportsTipsOnTotalAmount={supportsTipsOnTotalAmount}
              showMemberDetailPopup={showMemberDetailPopup}
              onPrintPress={onPrintPress}
              getManagerNotifications={getManagerNotifications}
              pendingItems={pendingCheckItems}
              showApprovalReasonsPopup={showApprovalReasonsPopup}
              currency={currency}
              iso2={iso2}
              suppressTipsOnFireBoard={suppressTipsOnFireBoard}
              isLayoutView={currentView === 'layout'}
              enableGpsLocation={enableGpsLocation}
              latitude={latitude}
              longitude={longitude}
              viewGuestLocationOnMap={viewGuestLocationOnMap}
              onRequestRefreshGuestGPS={onRequestRefreshGuestGPS}
              onClickSms={onClickSms}
              openCaptureSeatNamePopup={openCaptureSeatNamePopup}
              sendPendingItems={sendPendingItems}
              orderPendingItems={orderPendingItems}
              enableAgeRestrictedOrderingForSeat={enableAgeRestrictedOrderingForSeat}
              onUpdateAgeRestrictedItemsForSeat={onUpdateAgeRestrictedItemsForSeat}
              enableAgeRestrictedOrderingForCheck={enableAgeRestrictedOrderingForCheck}
              enableAgeVerification={enableAgeVerification}
            />
          </Aux>
        })}
      </Tabs>
    )
  };

  const getDefaultView = () => (
    <React.Fragment>
      <ChecksList
        checksRowData={checksRowData}
        setSelectedCheck={setSelectedCheck}
        selectedItem={selectedItem}
        showSearchBox={showSearchBox}
        handleChange={handleChange}
        searchChecks={searchChecks}
        onSearchReset={onSearchReset}
        selectedDate={selectedDate}
        onDateChange={onDateChange}
        onlineOrderAdvanceLimit={onlineOrderAdvanceLimit}
        resetFilterCalendar={resetFilterCalendar}
        isFutureOrderType={isFutureOrderType}
        activeMgrFilter={activeMgrFilter}
        managerMode={managerMode}
        currency={currency}
        iso2={iso2}
        currentView={currentView}
        sortModel={sortModel}
        updateSortModel={updateSortModel}
        showVoucherChecks={showVoucherChecks}
        pagination={pagination}
        checkFilters={checkFilters}
        sensorsMap={sensorsMap}
        fbVenueMode={fbVenueMode}
        counters={counters}
        setCounters={setCounters}
      />
      {showVoucherChecks && <RedeemButton onFooterIconPress={onFooterIconPress} />}
    </React.Fragment>
  );

  const getTableDeliveryView = () => (
    <CheckTilesView
      checksRowData={checksRowData}
      setSelectedCheck={setSelectedCheck}
      selectedItem={selectedItem}
      showSearchBox={showSearchBox}
      handleChange={handleChange}
      searchChecks={searchChecks}
      onSearchReset={onSearchReset}
      selectedDate={selectedDate}
      onDateChange={onDateChange}
      onlineOrderAdvanceLimit={onlineOrderAdvanceLimit}
      resetFilterCalendar={resetFilterCalendar}
      isFutureOrderType={isFutureOrderType}
      activeMgrFilter={activeMgrFilter}
      managerMode={managerMode}
      checkFilters={checkFilters}
      storeInfo={storeInfo}
      onHandleSms={onHandleSms}
      updateOrderStatus={updateOrderStatus}
      deviceGroup={deviceGroup}
      currentMode={currentMode}
      viewGuestLocationOnMap={viewGuestLocationOnMap}
      onOrderDelivered={onOrderDelivered}
    />
  );

  const getView = () => {
    switch (currentMode) {
      case modeEnums.TABLE_DELIVERY: return getTableDeliveryView();
      case modeEnums.GPS_LOCATION: return getTableDeliveryView();
      default:
        return getDefaultView();
    }
  };

  return (
    <div className={classes.container}>
      {currentView === 'layout' ? (
        <>
          <div className={classes.whiteboard}>
            <Whiteboard
              shapes={shapes}
              draggable={false}
              tableInfoColumn='stationNumber'
              selectShape={onSelectShape} 
              backgroundColor={'#2a2a2a'}
            />
            {selectedShape && !FireboardUtils.isObjectBlank(selectedItem) && (
              <ShapeInfoPopup
                selectedShape={selectedShape}
                selectedCheck={selectedItem}
                onClose={closeShapeInfoPopup}
              />
            )}
          </div>
          {(selectedTable && Array.isArray(selectedTable?.checks) && selectedTable.checks.length) ? getTabView() : <CheckDetails />}
        </>
      )
        : (
          <>
            <div className={classes.checklistContainer}>
              {getView()}
            </div>
            <CheckDetails
              selectedItem={selectedItem}
              items={items}
              supportsTipsOnTotalAmount={supportsTipsOnTotalAmount}
              showMemberDetailPopup={showMemberDetailPopup}
              onPrintPress={onPrintPress}
              getManagerNotifications={getManagerNotifications}
              pendingItems={pendingItems}
              showApprovalReasonsPopup={showApprovalReasonsPopup}
              currency={currency}
              iso2={iso2}
              suppressTipsOnFireBoard={suppressTipsOnFireBoard}
              acknowledgeIdCheck={acknowledgeIdCheck}
              enableGpsLocation={enableGpsLocation}
              latitude={latitude}
              longitude={longitude}
              viewGuestLocationOnMap={viewGuestLocationOnMap}
              onRequestRefreshGuestGPS={onRequestRefreshGuestGPS}
              onClickSms={onClickSms}
              openCaptureSeatNamePopup={openCaptureSeatNamePopup}
              orderPendingItems={orderPendingItems}
              sendPendingItems={sendPendingItems}
              enableAgeRestrictedOrderingForSeat={enableAgeRestrictedOrderingForSeat}
              onUpdateAgeRestrictedItemsForSeat={onUpdateAgeRestrictedItemsForSeat}
              enableAgeRestrictedOrderingForCheck={enableAgeRestrictedOrderingForCheck}
              enableAgeVerification={enableAgeVerification}
            />
          </>
        )}
    </div>
  );
}

const RedeemButton = ({ onFooterIconPress }) => {
  return (
    <div className={classes.voucherBtnWrapper}>
      <Button
        className={classes.voucherBtn}
        onClick={() => onFooterIconPress && onFooterIconPress('redeemOnlyVoucher')}>
        <img src={redeemVoucherImg} className={classes.voucherImg} />
        <div className={classes.voucherBtnText}>{constants.scanToRedeem}</div>
      </Button>
      <Button
        className={classes.voucherBtn}
        onClick={() => onFooterIconPress && onFooterIconPress('findVoucher')}>
        <img src={redeemVoucherImg} className={classes.voucherImg} />
        <div className={classes.voucherBtnText}>{constants.typeToRedeem}</div>
      </Button>
    </div>
  );
};
